/* eslint-disable react/prop-types */

import React, { useEffect, useRef, useState } from 'react';
import { FileUploader, FileDecoder } from 'api/endpoints/DigitizationUtility';
import { Form, Col, Modal, Button } from 'react-bootstrap';
import { FormLabel } from './FormLabel';
import { BsInfoCircleFill } from 'react-icons/bs';

const Document = ({ metadata, field, setValue }) => {
  const [uploadedFile, setUploadedFile] = useState(
    metadata.type === 'file' && metadata.defaultValue
  );
  const fileInputRef = useRef(null);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  useEffect(() => {
    const processFile = async () => {
      if (uploadedFile) {
        try {
          const decryptUrl = await FileDecoder(uploadedFile);
          decryptUrl ? setUploadedFile(decryptUrl) : setUploadedFile('');
        } catch (error) {
          console.error('File received failed:', error);
        }
      }
    };
    processFile();
  }, []);

  const handleFileChange = async e => {
    try {
      const { file, url } = await FileUploader(e, metadata);
      setValue(metadata.id, file);
      setUploadedFile(url);
    } catch (error) {
      console.error('File upload failed:', error);
    }
  };
  const handleClearImage = () => {
    setUploadedFile(null);
    setValue(metadata.id, '');
  };

  const handleUploadFile = () => {
    fileInputRef.current.click();
  };

  return (
    <Col>
      <Form.Group as={Col} sm={12} md={12} className="mb-3">
        <div className="flex justify-between items-center">
          <FormLabel
            label={metadata.label}
            required={metadata?.validation?.required}
          />
          <div
            style={{
              marginLeft: '5px',
              cursor: 'pointer',
              position: 'relative',
              display: 'inline-block'
            }}
            onClick={() => setTooltipVisible(!tooltipVisible)}
            title={`Accepting file types: ${metadata.uploadConfig.acceptedFileTypes.join(
              ', '
            )}
            Max File Size: ${metadata.uploadConfig.maxFileSizeMB} MB`}
          >
            <BsInfoCircleFill size={18} />
            {tooltipVisible && (
              <div
                style={{
                  position: 'absolute',
                  backgroundColor: '#f9f9f9',
                  border: '1px solid #ccc',
                  padding: '5px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  zIndex: '1',
                  width: '220px',
                  top: '100%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)'
                }}
              >
                {`Accepting file types: ${metadata.uploadConfig.acceptedFileTypes.join(
                  ', '
                )}
                Max File Size: ${metadata.uploadConfig.maxFileSizeMB} MB`}
              </div>
            )}
          </div>
          <Button
            variant="primary"
            onClick={handleUploadFile}
            style={{ marginLeft: '28px' }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-filetype-doc"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zm-7.839 9.166v.522q0 .384-.117.641a.86.86 0 0 1-.322.387.9.9 0 0 1-.469.126.9.9 0 0 1-.471-.126.87.87 0 0 1-.32-.386 1.55 1.55 0 0 1-.117-.642v-.522q0-.386.117-.641a.87.87 0 0 1 .32-.387.87.87 0 0 1 .471-.129q.264 0 .469.13a.86.86 0 0 1 .322.386q.117.255.117.641m.803.519v-.513q0-.565-.205-.972a1.46 1.46 0 0 0-.589-.63q-.381-.22-.917-.22-.533 0-.92.22a1.44 1.44 0 0 0-.589.627q-.204.406-.205.975v.513q0 .563.205.973.205.406.59.627.386.216.92.216.535 0 .916-.216.383-.22.59-.627.204-.41.204-.973M0 11.926v4h1.459q.603 0 .999-.238a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.59-.68q-.395-.234-1.004-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082H.79V12.57Zm7.422.483a1.7 1.7 0 0 0-.103.633v.495q0 .369.103.627a.83.83 0 0 0 .298.393.85.85 0 0 0 .478.131.9.9 0 0 0 .401-.088.7.7 0 0 0 .273-.248.8.8 0 0 0 .117-.364h.765v.076a1.27 1.27 0 0 1-.226.674q-.205.29-.55.454a1.8 1.8 0 0 1-.786.164q-.54 0-.914-.216a1.4 1.4 0 0 1-.571-.627q-.194-.408-.194-.976v-.498q0-.568.197-.978.195-.411.571-.633.378-.223.911-.223.328 0 .607.097.28.093.489.272a1.33 1.33 0 0 1 .466.964v.073H9.78a.85.85 0 0 0-.12-.38.7.7 0 0 0-.273-.261.8.8 0 0 0-.398-.097.8.8 0 0 0-.475.138.87.87 0 0 0-.301.398"
              />
            </svg>
          </Button>
        </div>
        <div className="mb-3">
          {uploadedFile ? (
            <div
              className="position-relative"
              style={{ width: '150px', height: '150px' }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="currentColor"
                className="bi bi-file-earmark-pdf"
                viewBox="0 0 16 16"
              >
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
              </svg>
              <button
                type="button"
                className="btn-close position-absolute"
                style={{ top: '5px', right: '5px', backgroundColor: 'white' }}
                aria-label="Close"
                onClick={handleClearImage}
              ></button>
              <a
                href={uploadedFile}
                download="downloaded_image.jpg"
                className="btn btn-primary position-absolute"
                style={{
                  bottom: '5px',
                  right: '5px',
                  fontSize: '12px',
                  padding: '5px',
                  backgroundColor: 'rgba(78, 78, 78, 0.7)',
                  color: 'white',
                  border: 'none'
                }}
              >
                Download
              </a>
            </div>
          ) : null}
        </div>
      </Form.Group>
      {/* Hidden file input */}
      <input
        type="file"
        ref={fileInputRef}
        accept={metadata.uploadConfig.acceptedFileTypes}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </Col>
  );
};

export default Document;
